import { useChatApi } from '../Services/ChatApiProvider';

const ButtonsContainer = ({ onChatClick }) => {
  const { channelSettings } = useChatApi();
  const btnName = (channelSettings?.askBoxFirstLine ?? '').toString().trim() || 'Chat';

  return (
    <div className="buttons-container">
      <button className="chat-button" onClick={onChatClick}>
        <span className="btn-bg-1"></span>
        <span className="btn-bg-2"></span>
        <span className="btn-bg-3"></span>
      </button>
      <div className="btn-name">{btnName}</div>
    </div>
  );
};

export default ButtonsContainer;
